// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--HedLQ","seo-block":"a10a3f92e9--seo-block--eyx0X","title":"a10a3f92e9--title--qVQVZ","link":"a10a3f92e9--link--wlITg"};